export default function usePublicPluginsMode() {
  const isPublicPluginsMode = process.env.REACT_APP_PUBLIC_URL === "/plugins";
  const urlPrefixPlugins = isPublicPluginsMode ? "" : "/app/plugins";
  const urlPrefixPlugin = isPublicPluginsMode ? "/plugin" : "/app/plugin";
  const urlPrefixApp = isPublicPluginsMode ? "" : "/app";
  const urlPrefixApiPlugins = isPublicPluginsMode ? "/plugins" : "";

  return { isPublicPluginsMode, urlPrefixPlugins, urlPrefixPlugin, urlPrefixApp, urlPrefixApiPlugins };
}
